import { Icon } from '@chakra-ui/react';

const PCAccordionIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M6.71,7.06c0.36-0.41,0.7-0.81,1.04-1.19C8.17,5.38,8.77,5.31,9.2,5.69c0.43,0.37,0.44,0.98,0.02,1.47
		C8.7,7.75,8.19,8.35,7.68,8.94c-0.6,0.68-1.35,0.68-1.94,0C5.21,8.33,4.68,7.72,4.16,7.11C3.77,6.65,3.8,6.05,4.21,5.69
		c0.43-0.37,1.03-0.31,1.44,0.15C6,6.24,6.34,6.64,6.71,7.06z"/>
			<g>
				<path class="st0" d="M27.3,13.77H3.28c-1.29,0-2.34-1.05-2.34-2.34V4.08c0-1.29,1.05-2.34,2.34-2.34H27.3
			c1.29,0,2.34,1.05,2.34,2.34v7.34C29.64,12.72,28.59,13.77,27.3,13.77z M3.28,2.68c-0.77,0-1.4,0.63-1.4,1.4v7.34
			c0,0.77,0.63,1.4,1.4,1.4H27.3c0.77,0,1.4-0.63,1.4-1.4V4.08c0-0.77-0.63-1.4-1.4-1.4H3.28z"/>
			</g>
		</g>
		<g>
			<path class="st0" d="M25.87,21.94H4.33c-1.41,0-2.56-1.15-2.56-2.56v-1.81c0-1.41,1.15-2.56,2.56-2.56h21.54
		c1.41,0,2.56,1.15,2.56,2.56v1.81C28.44,20.79,27.29,21.94,25.87,21.94z M4.33,16.03c-0.85,0-1.54,0.69-1.54,1.54v1.81
		c0,0.85,0.69,1.54,1.54,1.54h21.54c0.85,0,1.54-0.69,1.54-1.54v-1.81c0-0.85-0.69-1.54-1.54-1.54H4.33z"/>
		</g>
		<g>
			<path class="st0" d="M25.77,27.84H4.23c-1.41,0-2.56-1.15-2.56-2.56v-1.81c0-1.41,1.15-2.56,2.56-2.56h21.54
		c1.41,0,2.56,1.15,2.56,2.56v1.81C28.33,26.69,27.18,27.84,25.77,27.84z M4.23,21.94c-0.85,0-1.54,0.69-1.54,1.54v1.81
		c0,0.85,0.69,1.54,1.54,1.54h21.54c0.85,0,1.54-0.69,1.54-1.54v-1.81c0-0.85-0.69-1.54-1.54-1.54H4.23z"/>
		</g>

	</Icon>
);

export default PCAccordionIcon;
